export function getLocaleFromFilePath(
  filePath: string,
  { extension, defaultLocale }: { extension: string; defaultLocale: string },
) {
  const localePattern = new RegExp(
    `\\.([a-zA-Z\\-]{2,5})${extension ? `\\.${extension}` : ''}$`,
  )
  return filePath.match(localePattern)?.[1] ?? defaultLocale
}
